import type { IOpcionesEquiposNBS, IOpcionSelect } from '../../../modelos/CotizadorNBS';

/** Opciones del select más el valor actual del equipo si ya no está en la lista (catálogo desactivado después). */
export const conValorActual = (lista: IOpcionSelect[] | undefined, valor?: string, nombre?: string) =>
    !valor || (lista ?? []).some(o => o.value === valor)
        ? (lista ?? [])
        : [...(lista ?? []), { value: valor, label: `${nombre ?? valor} (inactivo)` }];

/** Máquinas del producto elegido (configuradas en el back). Sin producto o sin configuración: todas. */
export const maquinasDelProducto = (opciones: IOpcionesEquiposNBS | null | undefined, productoId?: string) => {
    const maquinas = opciones?.ascensores.maquinas ?? [];
    const permitidas = productoId ? opciones?.ascensores.maquinasPorProducto?.[productoId] : undefined;
    return permitidas ? maquinas.filter(m => permitidas.includes(m.value)) : maquinas;
};

/** Nombre de un ítem de catálogo por su id (valor del Select); si no está, usa el nombre que vino del back. */
export const nombreCatalogo = (lista: IOpcionSelect[] | undefined, id: string, respaldo?: string) =>
    lista?.find(o => o.value === id)?.label ?? respaldo ?? id;
